import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[boolStatus]' })
export class BoolStatusDirective implements AfterViewInit {
  @Input('boolStatus') public status!: boolean;

  constructor(private readonly _el: ElementRef) {}

  public ngAfterViewInit() {
    const element = this._el.nativeElement as HTMLElement;
    element.classList.add('flex', 'items-center');

    element.innerHTML = `<div class="h-2 w-2 rounded-full mobile:ml-8 mr-2 ${
      this.status ? 'bg-sky-green' : 'bg-sky-red'
    }"></div><span>${this.status ? 'Parkował' : 'Nie parkował'}</span>`;
  }
}
